export default __webpack_public_path__ + "static/media/Img190.d74e3b12.jpg";